
// import React, { useState, useEffect } from "react";
// import ModuleDetail from "../common/ModuleDetail";
// import DataApi from "../../api/dataApi";
// import { convertToUserTimezone } from "../../utils/convertTimeZone";
// import { Button, Col, Row } from "react-bootstrap";

// const PurchaseDetail = ({ permissions }) => {
//   const [externalData, setExternalData] = useState({ vendors: [], books: [] });
//   const [timeZone, setTimeZone] = useState(null);
//   const [currencySymbol, setCurrencySymbol] = useState("₹");
//   const [invoices, setInvoices] = useState([]);

//   const other = permissions?.allowEdit
//     ? {
//       other: [
//         { key: "createdbyid", label: "Created By", type: "text" },
//         { key: "lastmodifiedbyid", label: "Last Modified By", type: "text" },
//         {
//           key: "createddate",
//           label: "Created Date",
//           type: "date",
//           render: (value) => convertToUserTimezone(value, timeZone)
//         },
//         {
//           key: "lastmodifieddate",
//           label: "Last Modified Date",
//           type: "date",
//           render: (value) => convertToUserTimezone(value, timeZone)
//         },
//       ],
//     }
//     : {};

//   function getCompanyIdFromToken() {
//     const token = sessionStorage.getItem("token");
//     if (!token) return null;
//     const payload = JSON.parse(atob(token.split(".")[1]));
//     return payload.companyid || payload.companyid || null;
//   }

//   const fetchCompany = async () => {
//     try {
//       const companyid = getCompanyIdFromToken();
//       if (!companyid) return;
//       const companyApi = new DataApi("company");
//       const response = await companyApi.fetchById(companyid);
//       if (response?.data) {
//         setTimeZone(response.data.time_zone);
//         setCurrencySymbol(response.data.currency_symbol || "₹");
//       }
//     } catch (error) {
//       console.error("Error fetching company:", error);
//     }
//   };

//   useEffect(() => {
//     const fetchExternalData = async () => {
//       try {
//         const vendorApi = new DataApi("vendor/active");
//         const vendorsResponse = await vendorApi.fetchAll();
//         const vendors = vendorsResponse?.data?.data || vendorsResponse?.data || [];

//         const bookApi = new DataApi("book");
//         const booksResponse = await bookApi.fetchAll();
//         const books = booksResponse?.data?.data || booksResponse?.data || [];

//         setExternalData({
//           vendors: Array.isArray(vendors) ? vendors : [],
//           books: Array.isArray(books) ? books : [],
//         });
//       } catch (error) {
//         console.error("Error fetching external data:", error);
//       }
//     };

//     fetchExternalData();
//     fetchCompany();
//   }, []);

//   // Fetch invoices
//   const fetchInvoices = async () => {
//     try {
//       const invoiceApi = new DataApi("invoice");
//       const response = await invoiceApi.fetchAll();
//       const invoiceData = response?.data?.data || response?.data || [];
//       console.log("Fetched invoices:", invoiceData);
//       setInvoices(Array.isArray(invoiceData) ? invoiceData : []);
//     } catch (error) {
//       console.error("Error fetching invoices:", error);
//       setInvoices([]);
//     }
//   };

//   useEffect(() => {
//     fetchInvoices();
//   }, []); // Empty dependency array - sirf ek baar run hoga

//   const formatCurrency = (value) => {
//     if (value === null || value === undefined) return "-";
//     return `${currencySymbol}${parseFloat(value).toFixed(2)}`;
//   };

//   const fields = {
//     title: "purchase_serial_no",
//     subtitle: "book_title",

//     details: [
//       { key: "purchase_serial_no", label: "Purchase Serial No", type: "text" },
//       {
//         key: "vendor_id",
//         label: "Vendor",
//         type: "select",
//         options: "vendors",
//         displayKey: "vendor_name",
//         readOnly: true,
//         disable: true
//       },
//       {
//         key: "book_id",
//         label: "Book",
//         type: "select",
//         options: "books",
//         displayKey: "book_title"
//       },
//       { key: "quantity", label: "Quantity", type: "number", required: true },
//       {
//         key: "unit_price",
//         label: "Unit Price",
//         type: "number",
//         required: true,
//         render: (value) => formatCurrency(value)
//       },
//       {
//         key: "total_amount",
//         label: "Total Amount",
//         type: "number",
//         render: (value) => formatCurrency(value)
//       },
//       {
//         key: "purchase_date",
//         label: "Purchase Date",
//         type: "date",
//         render: (value) => convertToUserTimezone(value, timeZone)
//       },
//       {
//         key: "bill_number",
//         label: "Bill Number",
//         type: "text"
//       },
//       { key: "notes", label: "Notes", type: "textarea" },
//       { key: "status", label: "Status", type: "toggle" },
//     ],

//     ...other
//   };

//   if (fields && Array.isArray(fields.details)) {
//     fields.details = fields.details.map((f) => {
//       if (!f || !f.key) return f;
//       if (f.key === "status") return f;

//       const previousDisabled = f.disabled;

//       return {
//         ...f,
//         disabled: (rowData, isEditing) => {
//           if (isEditing) return true;
//           if (typeof previousDisabled === "function") return previousDisabled(rowData, isEditing);
//           return !!previousDisabled;
//         },
//       };
//     });
//   }

//   const lookupNavigation = {
//     vendor_name: {
//       path: "vendor",
//       idField: "vendor_id",
//       labelField: "vendor_name"
//     },
//     book_title: {
//       path: "book",
//       idField: "book_id",
//       labelField: "book_title"
//     }
//   };

//   return (
//     <>
//       <ModuleDetail
//         moduleName="purchase"
//         moduleApi="purchase"
//         moduleLabel="Purchase"
//         icon="fa-solid fa-shopping-cart"
//         fields={fields}
//         lookupNavigation={lookupNavigation}
//         permissions={permissions || {}}
//         externalData={externalData}
//       />

//       {/* Invoice Table Section */}
//       {/* <Row className="mt-4">
//         <Col>
//           <div className="invoice-section" style={{
//             border: '1px solid #dee2e6',
//             borderRadius: '8px',
//             padding: '20px',
//             backgroundColor: '#fff',
//             boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
//           }}>
//             <h5 className="mb-3" style={{ color: 'var(--primary-color)' }}>
//               <i className="fa-solid fa-file-invoice me-2"></i>
//               Invoice List
//             </h5>

//             {invoices.length > 0 ? (
//               <div style={{ overflowX: 'auto' }}>
//                 <table className="table table-bordered table-hover">
//                   <thead style={{ backgroundColor: '#f8f9fa' }}>
//                     <tr>
//                       <th>#</th>
//                       <th>Invoice No</th>
//                       <th>Purchase Serial No</th>
//                       <th>Vendor</th>
//                       <th>Book</th>
//                       <th>Quantity</th>
//                       <th>Unit Price</th>
//                       <th>Total Amount</th>
//                       <th>Invoice Date</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {invoices.map((invoice, index) => {
//                       // Get vendor name
//                       const vendor = externalData.vendors.find(v => v.id === invoice.vendor_id);
//                       const vendorName = vendor ? vendor.vendor_name || vendor.name : 'N/A';

//                       // Get book title
//                       const book = externalData.books.find(b => b.id === invoice.book_id);
//                       const bookTitle = book ? book.book_title || book.title : 'N/A';

//                       return (
//                         <tr key={invoice.id || index}>
//                           <td>{index + 1}</td>
//                           <td>
//                             <strong>{invoice.invoice_no || `INV-${invoice.id?.slice(-6) || '000000'}`}</strong>
//                           </td>
//                           <td>{invoice.purchase_serial_no || '—'}</td>
//                           <td>{vendorName}</td>
//                           <td>{bookTitle}</td>
//                           <td className="text-center">{invoice.quantity || 0}</td>
//                           <td className="text-right">{formatCurrency(invoice.unit_price)}</td>
//                           <td className="text-right">
//                             <strong style={{ color: 'var(--primary-color)' }}>
//                               {formatCurrency(invoice.total_amount || (invoice.quantity * invoice.unit_price))}
//                             </strong>
//                           </td>
//                           <td className="text-center">
//                             {invoice.invoice_date ?
//                               new Date(invoice.invoice_date).toLocaleDateString('en-IN') :
//                               invoice.purchase_date ?
//                                 new Date(invoice.purchase_date).toLocaleDateString('en-IN') : '—'}
//                           </td>
//                           <td>
//                             <span style={{
//                               backgroundColor: invoice.status === 'paid' ? '#d4edda' :
//                                 invoice.status === 'pending' ? '#fff3cd' : '#f8d7da',
//                               color: invoice.status === 'paid' ? '#155724' :
//                                 invoice.status === 'pending' ? '#856404' : '#721c24',
//                               padding: '3px 8px',
//                               borderRadius: '4px',
//                               fontSize: '12px',
//                               display: 'inline-block'
//                             }}>
//                               {(invoice.status || 'pending').toUpperCase()}
//                             </span>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             ) : (
//               <div style={{
//                 textAlign: 'center',
//                 padding: '40px',
//                 backgroundColor: '#f8f9fa',
//                 borderRadius: '8px'
//               }}>
//                 <i className="fa-solid fa-file-invoice fa-3x text-muted mb-3"></i>
//                 <p className="text-muted mb-0">No invoices found</p>
//               </div>
//             )}

//             {/* Summary Section */}
//       {/* {invoices.length > 0 && (
//         <div className="mt-3 p-3" style={{
//           backgroundColor: '#f8f9fa',
//           borderRadius: '8px',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center'
//         }}>
//           <div>
//             <strong>Total Invoices:</strong> {invoices.length}
//           </div>
//           <div>
//             <strong>Total Amount:</strong>{' '}
//             <span style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}>
//               {formatCurrency(invoices.reduce((sum, inv) =>
//                 sum + (inv.total_amount || (inv.quantity * inv.unit_price) || 0), 0))}
//             </span>
//           </div>
//         </div>
//       )}
//     </div >
//         </Col >
//       </Row > */}
//       {/* 
//       <style>{`
//         .text-right {
//           text-align: right;
//         }
//         .text-center {
//           text-align: center;
//         }
//         .table th {
//           background-color: #f8f9fa;
//           font-weight: 600;
//         }
//         .table td {
//           vertical-align: middle;
//         }
//       `}</style> */}
//     </>
//   );
// };

// export default PurchaseDetail;



import React, { useState, useEffect } from "react";
import ModuleDetail from "../common/ModuleDetail";
import DataApi from "../../api/dataApi";
import { convertToUserTimezone } from "../../utils/convertTimeZone";
import { Button, Col, Row } from "react-bootstrap";

const PurchaseDetail = ({ permissions }) => {
  const [externalData, setExternalData] = useState({ vendors: [], books: [] });
  const [timeZone, setTimeZone] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [invoices, setInvoices] = useState([]);

  const other = permissions?.allowEdit
    ? {
      other: [
        { key: "createdbyid", label: "Created By", type: "text" },
        { key: "lastmodifiedbyid", label: "Last Modified By", type: "text" },
        {
          key: "createddate",
          label: "Created Date",
          type: "date",
          render: (value) => convertToUserTimezone(value, timeZone)
        },
        {
          key: "lastmodifieddate",
          label: "Last Modified Date",
          type: "date",
          render: (value) => convertToUserTimezone(value, timeZone)
        },
      ],
    }
    : {};

  function getCompanyIdFromToken() {
    const token = sessionStorage.getItem("token");
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.companyid || payload.companyid || null;
  }

  const fetchCompany = async () => {
    try {
      const companyid = getCompanyIdFromToken();
      if (!companyid) return;
      const companyApi = new DataApi("company");
      const response = await companyApi.fetchById(companyid);
      if (response?.data) {
        setTimeZone(response.data.time_zone);
        setCurrencySymbol(response.data.currency_symbol || "₹");
      }
    } catch (error) {
      console.error("Error fetching company:", error);
    }
  };

  useEffect(() => {
    const fetchExternalData = async () => {
      try {
        const vendorApi = new DataApi("vendor/active");
        const vendorsResponse = await vendorApi.fetchAll();
        const vendors = vendorsResponse?.data?.data || vendorsResponse?.data || [];

        const bookApi = new DataApi("book");
        const booksResponse = await bookApi.fetchAll();
        const books = booksResponse?.data?.data || booksResponse?.data || [];

        setExternalData({
          vendors: Array.isArray(vendors) ? vendors : [],
          books: Array.isArray(books) ? books : [],
        });
      } catch (error) {
        console.error("Error fetching external data:", error);
      }
    };

    fetchExternalData();
    fetchCompany();
  }, []);

  // Fetch invoices
  const fetchInvoices = async () => {
    try {
      const invoiceApi = new DataApi("invoice");
      const response = await invoiceApi.fetchAll();
      const invoiceData = response?.data?.data || response?.data || [];
      console.log("Fetched invoices:", invoiceData);
      setInvoices(Array.isArray(invoiceData) ? invoiceData : []);
    } catch (error) {
      console.error("Error fetching invoices:", error);
      setInvoices([]);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  const formatCurrency = (value) => {
    if (value === null || value === undefined) return "-";
    return `${currencySymbol}${parseFloat(value).toFixed(2)}`;
  };

  const fields = {
    title: "purchase_serial_no",
    subtitle: "book_title",

    details: [
      { key: "purchase_serial_no", label: "Purchase Serial No", type: "text" },
      {
        key: "vendor_id",
        label: "Vendor",
        type: "select",
        options: "vendors",
        displayKey: "vendor_name",
        readOnly: true,
        disabled: true,
        render: (value) => {
          if (!value) return "—";
          const vendor = externalData.vendors.find((v) => v.id === value);
          return vendor ? (vendor.vendor_name || vendor.name || vendor.company_name || value) : value;
        }
      },
      {
        key: "book_id",
        label: "Book",
        type: "select",
        options: "books",
        displayKey: "book_title",
        readOnly: true,
        disabled: true,
        render: (value) => {
          if (!value) return "—";
          const book = externalData.books.find((b) => b.id === value);
          return book ? (book.book_title || book.title || book.name || value) : value;
        }
      },
      { key: "quantity", label: "Quantity", type: "number", required: true },
      {
        key: "unit_price",
        label: "Unit Price",
        type: "number",
        required: true,
        render: (value) => formatCurrency(value)
      },
      {
        key: "total_amount",
        label: "Total Amount",
        type: "number",
        render: (value) => formatCurrency(value)
      },
      {
        key: "purchase_date",
        label: "Purchase Date",
        type: "date",
        render: (value) => convertToUserTimezone(value, timeZone)
      },
      {
        key: "bill_number",
        label: "Bill Number",
        type: "text"
      },
      { key: "notes", label: "Notes", type: "textarea" },
      { key: "status", label: "Status", type: "toggle" },
    ],

    ...other
  };

  if (fields && Array.isArray(fields.details)) {
    fields.details = fields.details.map((f) => {
      if (!f || !f.key) return f;
      if (f.key === "status") return f;

      const previousDisabled = f.disabled;

      return {
        ...f,
        disabled: (rowData, isEditing) => {
          if (isEditing) return true;
          if (typeof previousDisabled === "function") return previousDisabled(rowData, isEditing);
          return !!previousDisabled;
        },
      };
    });
  }

  const lookupNavigation = {
    // Keys updated to match the field keys in your details array
    vendor_id: {
      path: "vendor",
      idField: "vendor_id",
      labelField: "vendor_name"
    },
    book_id: {
      path: "book",
      idField: "book_id",
      labelField: "book_title"
    }
  };

  return (
    <>
      <ModuleDetail
        moduleName="purchase"
        moduleApi="purchase"
        moduleLabel="Purchase"
        icon="fa-solid fa-shopping-cart"
        fields={fields}
        lookupNavigation={lookupNavigation}
        permissions={permissions || {}}
        externalData={externalData}
      />

      {/* Invoice Table Section */}
      {/* <Row className="mt-4">
        <Col>
          <div className="invoice-section" style={{
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            padding: '20px',
            backgroundColor: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
          }}>
            <h5 className="mb-3" style={{ color: 'var(--primary-color)' }}>
              <i className="fa-solid fa-file-invoice me-2"></i>
              Invoice List
            </h5>

            {invoices.length > 0 ? (
              <div style={{ overflowX: 'auto' }}>
                <table className="table table-bordered table-hover">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      <th>#</th>
                      <th>Invoice No</th>
                      <th>Purchase Serial No</th>
                      <th>Vendor</th>
                      <th>Book</th>
                      <th>Quantity</th>
                      <th>Unit Price</th>
                      <th>Total Amount</th>
                      <th>Invoice Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoices.map((invoice, index) => {
                      // Get vendor name
                      const vendor = externalData.vendors.find(v => v.id === invoice.vendor_id);
                      const vendorName = vendor ? vendor.vendor_name || vendor.name : 'N/A';

                      // Get book title
                      const book = externalData.books.find(b => b.id === invoice.book_id);
                      const bookTitle = book ? book.book_title || book.title : 'N/A';

                      return (
                        <tr key={invoice.id || index}>
                          <td>{index + 1}</td>
                          <td>
                            <strong>{invoice.invoice_no || `INV-${invoice.id?.slice(-6) || '000000'}`}</strong>
                          </td>
                          <td>{invoice.purchase_serial_no || '—'}</td>
                          <td>{vendorName}</td>
                          <td>{bookTitle}</td>
                          <td className="text-center">{invoice.quantity || 0}</td>
                          <td className="text-right">{formatCurrency(invoice.unit_price)}</td>
                          <td className="text-right">
                            <strong style={{ color: 'var(--primary-color)' }}>
                              {formatCurrency(invoice.total_amount || (invoice.quantity * invoice.unit_price))}
                            </strong>
                          </td>
                          <td className="text-center">
                            {invoice.invoice_date ?
                              new Date(invoice.invoice_date).toLocaleDateString('en-IN') :
                              invoice.purchase_date ?
                                new Date(invoice.purchase_date).toLocaleDateString('en-IN') : '—'}
                          </td>
                          <td>
                            <span style={{
                              backgroundColor: invoice.status === 'paid' ? '#d4edda' :
                                invoice.status === 'pending' ? '#fff3cd' : '#f8d7da',
                              color: invoice.status === 'paid' ? '#155724' :
                                invoice.status === 'pending' ? '#856404' : '#721c24',
                              padding: '3px 8px',
                              borderRadius: '4px',
                              fontSize: '12px',
                              display: 'inline-block'
                            }}>
                              {(invoice.status || 'pending').toUpperCase()}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={{
                textAlign: 'center',
                padding: '40px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px'
              }}>
                <i className="fa-solid fa-file-invoice fa-3x text-muted mb-3"></i>
                <p className="text-muted mb-0">No invoices found</p>
              </div>
            )}

            {/* Summary Section */}
      {/* {invoices.length > 0 && (
        <div className="mt-3 p-3" style={{
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <strong>Total Invoices:</strong> {invoices.length}
          </div>
          <div>
            <strong>Total Amount:</strong>{' '}
            <span style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}>
              {formatCurrency(invoices.reduce((sum, inv) =>
                sum + (inv.total_amount || (inv.quantity * inv.unit_price) || 0), 0))}
            </span>
          </div>
        </div>
      )}
    </div >
        </Col >
      </Row > */}
      {/* <style>{`
        .text-right {
          text-align: right;
        }
        .text-center {
          text-align: center;
        }
        .table th {
          background-color: #f8f9fa;
          font-weight: 600;
        }
        .table td {
          vertical-align: middle;
        }
      `}</style> */}
    </>
  );
};

export default PurchaseDetail;